module.exports = __webpack_public_path__ + "static/logo-2f22c28e134b2e72f46551c2c0713b27.png";